import MergerIcon from './MergerIcon'

export default MergerIcon
